import { AxiosResponse } from 'axios';
import { ApiErrorDTO, ApiValidationErrorItemDTO } from './dto';

export const isApiError = (error: AxiosResponse): error is AxiosResponse<ApiErrorDTO<ApiValidationErrorItemDTO>> => {
    const { data } = error;
    return data != null && typeof data === 'object' && 'messageEn' in data;
};
